module.exports = __webpack_public_path__ + "static/dog-m-gray-b08be3421304e3b8209af7fb6aebc261.jpg";